import { useQueryClient, InfiniteData } from "@tanstack/react-query";
import { useCallback } from "react";
import { useTenantRouteContext } from "@/components/app-shell/TenantRouteContext";
import { deepMerge, DeepPartial } from "@/lib/object";
import { PatientSearchResult } from "lib/api-types/schemas";
import type { TokenPagedResult } from "@/lib/query/useTokenPagedInfiniteQuery";

type PatientSearchInfiniteData = InfiniteData<
  TokenPagedResult<PatientSearchResult>
>;

export function useUpdatePatientSearchCache() {
  const queryClient = useQueryClient();
  const { tenantId } = useTenantRouteContext();

  return useCallback(
    (patientId: string, patch: DeepPartial<PatientSearchResult>) => {
      queryClient.setQueriesData<PatientSearchInfiniteData>(
        { queryKey: ["patients", "search", tenantId] },
        (data) => {
          if (!data) return data;

          return {
            ...data,
            pages: data.pages.map((page) => ({
              ...page,
              items: page.items.map((item) =>
                item.patientId === patientId
                  ? deepMerge(item, patch)
                  : item,
              ),
            })),
          };
        },
      );
    },
    [tenantId, queryClient],
  );
}
